import { PriceMoney } from "@/modules/location";
import { Sale } from "@/modules/ooc/sale";
import OocTabInterface from "@/interface/app/ooc/tab.interface";
import OocSaleInterface from "@/interface/app/ooc/sale.interface";

export class OocTab implements OocTabInterface {
  total_amount: string = new PriceMoney({ amount: 0 }).getPricePackage();
  tabTotal_amount: string = new PriceMoney({ amount: 0 }).getPricePackage();
  sale: OocSaleInterface = new Sale();
  notes?: any;
  total: number = 0;
  tabTotal?: number;
  constructor(data) {
    if (data) {
      this.total_amount = new PriceMoney({ amount: data.total_amount }).getPricePackage();
      this.sale = new Sale(data.sale);
      this.notes = data.notes;
      this.total = data.total_amount;
      this.calculateTotal();
    }
  }

  /**
   * calculate the bill total with the delivery
   * @private
   */
  private calculateTotal() {
    this.tabTotal = this.total + this.sale?.delivery || 0;
    this.tabTotal_amount = new PriceMoney({ amount: this.tabTotal }).getPricePackage();
  }
}
